import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { categorySchema } from "../../../lib/schemas/categorySchema";
import { useCategories } from "../../../lib/hooks/useCategories";
import { uploadCategory } from "../../../lib/services/categoryService";

/* Centered modal with backdrop */
const CreateCategoryForm = ({ onClose }) => {
  const { categories, setCategories } = useCategories();

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: zodResolver(categorySchema),
    mode: "all",
    defaultValues: {
      id: undefined,
      name: undefined,
    },
  });

  // Close with ESC key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const onSubmit = async () => {
    const response = await uploadCategory(getValues("id"), getValues("name"));
    const data = await response.json();

    if (response.ok) {
      const unsorted = [
        ...categories,
        { ...data.data, id: Number(data.data.id) },
      ];
      const sorted = unsorted.sort(function (a, b) {
        return a.id - b.id;
      });
      setCategories(sorted);
    } else {
      alert(`Error uploading category: ${data.error}`);
    }

    onClose();
  };

  return (
    <div
      className="confirm-overlay rounded mt-5"
      role="presentation"
      onClick={onClose}
    >
      {/* stop propagation so clicks inside the card don't close */}
      <div
        className="confirm-card col-2"
        role="dialog"
        aria-modal="true"
        style={{
          width: "auto",
          backgroundColor: "rgb(237, 71, 9)",
          outline: "none",
          border: "none",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex flex-row gap-5" style={{ color: "white" }}>
            <div className="d-flex flex-column gap-4" style={{ width: "40vh" }}>
              <div className="form-group flex-row">
                <div>
                  <label className="form-label">Category ID</label>
                  <input
                    type="number"
                    {...register("id", {
                      setValueAs: (val) =>
                        val === "" ? undefined : Number(val),
                    })}
                  />
                </div>
                <div>{errors.id && <small>{errors.id.message}</small>}</div>
              </div>

              <div className="form-group flex-row">
                <div>
                  <label className="form-label">Category Name</label>
                  <input type="text" {...register("name")} />
                </div>
                <div>{errors.name && <small>{errors.name.message}</small>}</div>
              </div>
            </div>
          </div>

          <div className="confirm-actions mt-4">
            <button
              className="btn confirm-no"
              style={{
                outline: "none",
                border: "none",
                color: "white",
                backgroundColor: "darkgreen",
              }}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn confirm-yes"
              style={{
                outline: "none",
                border: "none",
                color: "white",
                backgroundColor: "darkgreen",
              }}
              disabled={errors?.id || errors?.name}
            >
              Create Category
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCategoryForm;
